// src/services/changesApi.jsx
import { coreGet, coreApiBaseUrl } from "@/services/coreApi"
import { checkAndRefreshToken } from "@/services/auth"

export async function getChanges(since, accessContext, setAccessContext) {
  const qs = since == null ? "" : `?since=${since}`
  return coreGet(`/changes${qs}`, accessContext, setAccessContext, ".core /changes error=")
}

// Eigener Fetch statt coreGet: der Response-Body ist ein endloser
// text/event-stream und darf nicht als Ganzes gelesen werden.
export async function openChangeStream({ since, accessContext, setAccessContext, signal }) {
  const coreApiUrl = coreApiBaseUrl(accessContext)
  const accessToken = await checkAndRefreshToken(accessContext, setAccessContext)
  if (!accessToken) throw new Error("Failed to get access token")

  const qs = since == null ? "" : `?since=${since}`
  const res = await fetch(`${coreApiUrl}/changes/stream${qs}`, {
    headers: {
      Accept: "text/event-stream",
      Authorization: `Bearer ${accessToken}`,
    },
    signal,
  })
  if (!res.ok || !res.body) {
    const err = new Error(`.core /changes/stream error= ${res.status}`)
    err.status = res.status
    throw err
  }
  return res
}
